"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiChatFill16 = {
    paths: [
        {
            path: 'M10.7923208,11.750772 C10.403066,12.1400268 9.76465983,12.1327272 9.37955379,11.7476211 L7.63193268,10 L4.99668583,10 C2.23709245,10 0,7.75580481 0,5 C0,2.23857625 2.24157855,0 4.99668583,0 L11.0033142,0 C13.7629076,0 16,2.24419519 16,5 C16,7.07793887 14.7307318,8.85982134 12.9284965,9.61459625 L10.7923208,11.750772 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Chat',
    width: 16,
    height: 12,
};
var muiChatFill24 = {
    paths: [
        {
            path: 'M15.9553488,17.5080651 C15.5613153,17.9020986 14.9296822,17.9093199 14.5349437,17.5145814 L12.0039186,14.9835563 L7.48681235,14.9835563 C3.35196007,14.9835563 0,11.6209538 0,7.49177815 C0,3.35418333 3.35868184,0 7.48681235,0 L16.4868777,0 C20.62173,0 23.9736901,3.3626025 23.9736901,7.49177815 C23.9736901,10.7956688 21.8321596,13.600048 18.8673682,14.5960457 L15.9553488,17.5080651 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Chat',
    width: 24,
    height: 18,
};
var muiChatFill = {
    base: muiChatFill16,
    smIcon: muiChatFill16,
    lgIcon: muiChatFill24,
};
exports.muiChatFill = muiChatFill;
//# sourceMappingURL=chatFill.js.map